import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyStateCard from '../../../components/EmptyStateCard';

export const EmptyPerformanceReview: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { t } = useTranslation();
  return <EmptyStateCard title={t('performanceReview.emptyState.title')} />;
};
